<template>
	<div class="incenters">
		<div style="">
			<!--  -->
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增"
				fontSize="14px" @btnclick="addckd">
			</Commonbtn>
			<!---->
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" :optional="editops" opwidth="72px" top="370px"
				:src="require('@/assets/icon/icon-update.png')" title="修改" fontSize="14px" @btnclick="updateckd">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="审核" fontSize="14px" @btnclick="shen"
				:src="require('@/assets/icon/shen.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.revoke" title="弃审" fontSize="14px" @btnclick="qshen"
				:src="require('@/assets/icon/shua.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="OtherOutExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
		</div>
		<div class="TableWidth" v-if="CusTypeFlog == 0">
			<Commontable ref="OutboudreRef" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=511 :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<div class="TableWidth" v-else>
			<Commontable ref="OutboudreRef" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick"
				colnum=511 :tableData="tableData" :headerData="headerDataTow" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom ref="dialogadd" width="1000px" title="新增出库单" :OKASCAN="false"
			:dialogVisible="dialogVisibleoutboundorder" @cancel="canceloutboundorder"
			@dialogOK="dialogOKcanceloutboundorder">
			<div class="froms">
				<div style="border-bottom: 1px solid #f0f0f0;">
					<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="保存"
						fontSize="14px" @btnclick="addsave">
					</Commonbtn>
					<div v-if="Detailflag" style="display: inline-block">
						<CommonbtnUpLoad backgroundColor="#FFF" title="上传出库明细" fontSize="14px" @getFile="UnImport"
							:src="require('@/assets/icon/icon-drjys.png')">
						</CommonbtnUpLoad>
						<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
							@click="dowload">下载导入模版</a>
					</div>
					<div v-if="Uniqueflag" style="display: inline-block">
						<CommonbtnUpLoad backgroundColor="#FFF" title="上传出库唯一码明细" fontSize="14px" @getFile="UniqImport"
							:src="require('@/assets/icon/icon-drjys.png')">
						</CommonbtnUpLoad>
						<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
							@click="Uniqdowload">下载导入模版</a>
					</div>
				</div>

				<div style="width: 960px;border-bottom: 1px solid #f0f0f0;background-color: #ffffff;padding-bottom: 15px;animation: shows 0.2s linear;overflow: hidden;"
					v-if="showorhide">
					<div v-for="(item , index) of formdatadialog" :key="index+'add'" style="display: inline-block;">
						<Commondropdownlist ref="outadd" :loading="loading" :selcoms="item.selcoms" :event="item.event"
							@remoteHosType="remoteHosType" @invClass="invClass" @HosTypeChage="HosTypeChage"
							@remoteMethodtows="remoteMethodtows($event,index)" :btx="item.btx" :key="index"
							:options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth"
							:minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith"
							:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
							:color="item.color" :placeholder="item.placeholder" :types="item.types"
							:inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
					</div>
				</div>
			</div>
			<div style="width: 970px;">
				<AddDialogFromTable :wtypes="wtypes" :invClassCode="invClassCode" ref="AddDialog"
					@handleSelectionChange="handleSelectionChangeAddDialogFromTable" @addclick="addclick" width="500px"
					colnum=7 :dpmid="dpmid" :state="state" :tableData="tableDataMD" height="100%">
				</AddDialogFromTable>
			</div>

		</DialogFrom>
		<DialogFrom width="1000px" title="修改出库单" :OKASCAN="false" :dialogVisible="dialogVisibleoutboundorderedit"
			@cancel="canceloutboundorderedit" @dialogOK="dialogOKcanceloutboundorderedit">
			<div class="froms">
				<div style="border-bottom: 1px solid #f0f0f0;">
					<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="保存"
						fontSize="14px" @btnclick="editsave">
					</Commonbtn>
					<div v-if="Detailflag" style="display: inline-block">
						<CommonbtnUpLoad backgroundColor="#FFF" title="上传出库明细" fontSize="14px" @getFile="UnImport"
							:src="require('@/assets/icon/icon-drjys.png')">
						</CommonbtnUpLoad>
						<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
							@click="dowload">下载导入模版</a>
					</div>
					<div v-if="Uniqueflag" style="display: inline-block">
						<CommonbtnUpLoad backgroundColor="#FFF" title="上传出库唯一码明细" fontSize="14px" @getFile="UniqImport"
							:src="require('@/assets/icon/icon-drjys.png')">
						</CommonbtnUpLoad>
						<a style="display: inline-block;font-size: 14px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
							@click="Uniqdowload">下载导入模版</a>
					</div>

				</div>
				<div class="inputtop"
					style="width: 960px !important;border-bottom: 1px solid #f0f0f0;background-color: #ffffff;padding-bottom: 15px;animation: shows 0.2s linear;overflow: hidden;"
					v-if="showorhide">
					<div v-for="(item , index) of editformdatadialog" :key="index+'update'"
						style="display: inline-block;">
						<Commondropdownlist ref="outupdate" :loading="loading" :selcoms="item.selcoms"
							@remoteHosType="remoteHosType" :event="item.event" @invClass="invClass"
							@HosTypeChage="HosTypeChage" @remoteMethodtows="remoteMethodtows" :btx="item.btx"
							:key="index" :options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth"
							:minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith"
							:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
							:color="item.color" :placeholder="item.placeholder" :types="item.types"
							:inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
					</div>
				</div>
			</div>
			<div style="width: 970px;">
				<AddDialogFromTable ref="AddDialog" :invClassCode="invClassCode" :dialogindex="dialogindex"
					@handleSelectionChanges="handleSelectionChanges"
					@handleSelectionChange="handleSelectionChangeAddDialogFromTable" @addclick="addclick" width="500px"
					:dpmid="dpmid" :state="state" :tableData="tableDataMD" height="100%">
				</AddDialogFromTable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" title="出库上报管理指导视频" :OKASCAN="false" :dialogVisible="dialogVisibGuidanceVideo"
			@cancel="cancelGuidanceVideo" @dialogOK="dialogOKGuidanceVideo">
			<VideoPlayer ref="outbouVideo" v-if="dialogVisibGuidanceVideo" :srcVideo="require('../../../../assets/video/outbou/outbou.mp4')">
			</VideoPlayer>
		</DialogFrom>
		<DialogFrom width="648px" title="发票照片标注" :dialogVisible="dialogVisiblesinvoicephoto"
			@cancel="cancelinvoicephoto" @dialogOK="dialogOKinvoicephoto">
			<div style="color: #333333;font-size: 14px;">
				请填写发票照片校验状态标注：
			</div>
			<textarea style="border: 1px solid #E6E6E6;width: 608px;height: 180px;margin-top: 10px;"></textarea>
		</DialogFrom>
		<DialogFrom width="890px" title="导入结果" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesqsjg" @cancel="cancelqsjg"
			@dialogOK="dialogOKqsjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDataqsjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条出库上报信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleqshen" @cancel="cancelqshen"
			@dialogOK="dialogOKqshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要弃审这条出库上报信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleshen" @cancel="cancelshen"
			@dialogOK="dialogOKshen" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审核通过这条出库上报信息吗？</span>
		</Dialog>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import Dialog from '../../../../components/dialog.vue'
	import AddDialogFromTable from './components/addDialogFromTable.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import addformdatadialog from '../fromData/addformdatadialog'
	import editformdatadialog from '../fromData/editformdatadialog'
	import headerData from '../table/headerData'
	import headerDataTow from '../table/headerDataTow'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import VideoPlayer from '../../../../components/videoPlayer.vue'
	import {
		wmsOtherOutInfo,
		OtherOutImportDetail,
		HelperDPVoucherType,
		InventoryClassList,
		wmsOtherOutImport,
		CusType,
		CustomerList,
		HospitalList,
		wmsOtherOutDelete,
		wmsOtherOutVerify,
		wmsOtherOutUnVerify,
		InventoryClassInfo,
		OtherOutDownloadDetailTemplet,
		OtherOutImportUnique,
		OtherOutDownloadUniqueTemplet,
		OtherOutDownloadTemplet,
		OtherOutEdit,
		OtherOutAdd,
		HospitalInfo
	} from '@/api/home'
	export default {
		name: 'outnoundreport',
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			CommonBtngroup,
			AddDialogFromTable,
			CommonbtnUpLoad,
			VideoPlayer
		},
		props: {
			tableData: {
				type: Array,
				default: Array
			},
			total: {
				type: Number,
				default: 0
			},
			tableDataMD: {
				type: Array,
				default: []
			},
		},
		data: function() {
			return {
				dialogVisibleoutboundorderedit: false,
				dialogVisibles: false,
				dialogVisibleshen: false,
				dialogVisibleqshen: false,
				dialogVisibleqdel: false,
				dialogVisiblesinvoicephoto: false,
				dialogVisibledel: false,
				dialogVisibleoutboundorder: false,
				dialogVisiblesdrjg: false,
				dialogVisiblesqsjg: false,
				dialogVisibGuidanceVideo: false,
				Detailflag: true,
				Uniqueflag: false,
				editops: true,
				showorhide: true,
				rowboo: false,
				loading: false,
				dpmid: null,
				// optionalupdate: false,
				CusTypeFlog: null,
				tableDataqsjg: [],
				formdatadialog: [],
				editformdatadialog: [],
				dpmidarr: [],
				invClassCode: "",
				title: '',
				dialogindex: '',
				TerminalHospital: '',
				TerminalHospitalName: '',
				wtypes: 1,
				HosTypestate: null,
				headerData: [],
				headerDataTow: [],
				fromdatalists: [{
					inputdata: '',
					fontSize: '14px',
					color: '#333333',
					placeholder: '颜色说明',
					types: '',
					inputtype: 'selects',
					width: '110px',
				}, ],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
				},
				tableDatadrjg: [],
				AddTableSelectiondetailList: [],
				AddTableSelectiondetailUniqueList: [],
				state: [{
					title: '明细'
				}, ],
				CusTypeState: "",
				HospitalCode: "",
				CusCode: "",
				HospitalName: "",
				CusCodeName: "",
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.formdatadialog = JSON.parse(JSON.stringify(addformdatadialog))
			this.editformdatadialog = JSON.parse(JSON.stringify(editformdatadialog))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDataTow = JSON.parse(JSON.stringify(headerDataTow))
			this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				let NodeID = this.$route.query.NodeID
				data.Menus.map((item, index) => {
					if (item.NodeID == 18) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 128) {
								this.qus = items.Nodes
							}
						})
					}
				})
				//console.log(this.qus, 'qus');
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'revoke') {
							this.qx.revoke = true
						}
					})
				}
				this.CusType()
			},
			async dowloadBtn() {
				let {
					data,
					code,
					message
				} = await OtherOutDownloadTemplet({})

				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 下载模板
			async dowload() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await OtherOutDownloadDetailTemplet({})
				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 上传出库明细
			async UnImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await OtherOutImportDetail(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					//console.log(this.$refs.AddDialog, 'adddialog');
					this.$refs.AddDialog.tableDataDetail = data.DetailList
					this.$refs.AddDialog.tableDataDetailunNo = data.DetailList
					// data.DetailList.map((item, index) => {
					//   this.$refs.AddDialog.tableDataDetail.push(item)
					// })
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			// 上传出库唯一码明细
			async UniqImport(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await OtherOutImportUnique(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					let arr = []
					let obj = {}
					data.UniqueList.map((item, index) => {
						let num = parseInt(Math.random() * 10000)
						obj = Object.assign({}, item, {
							ids: num
						})
						arr.push(obj)
					})


					this.$refs.AddDialog.tableDataDetailUnique = arr
					this.$refs.AddDialog.tableDataDetail = data.DetailList
					this.$refs.AddDialog.tableDataDetailunNo = data.DetailList
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
			},
			// 下载出库唯一码明细
			async Uniqdowload() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"

				let {
					data,
					code,
					message
				} = await OtherOutDownloadUniqueTemplet({})
				if (code == 0) {
					window.location.href = data
					// this.downURL(data)
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			async OtherOutEditTow(val) {
				// if (!this.$refs.outupdate[0].modelvalue) {
				//   this.$message.warning("出库单号不能为空！")
				//   return
				// }
				if (!this.$refs.outupdate[1].modelvalue) {
					this.$message.warning("出库日期不能为空！")
					return
				}
				if (!this.$refs.outupdate[2].modelvalue) {
					this.$message.warning("产品线不能为空！")
					return
				}
				if (!this.$refs.outupdate[3].modelvalue) {
					this.$message.warning("单据类型不能为空！")
					return
				}
				if (!this.$refs.outupdate[4].modelvalue) {
					this.$message.warning("付款方不能为空！")
					return
				}
				let {
					code,
					data,
					message
				} = await OtherOutEdit({
					dpmid: this.dpmid,
					dpDate: this.$refs.outupdate[1].modelvalue, //出库日期
					voucherType: this.$refs.outupdate[3].modelvalue, //单据类型
					invClass: this.$refs.outupdate[2].modelvalue, //产品线编码
					vouCode: this.$refs.outupdate[0].modelvalue, //经销商出库单号
					cusCode: this.$refs.outupdate[4].modelvalue, //二级经销商编号
					// hospital: this.$refs.outupdate[4].modelvalue == this.HospitalName ? this.HospitalCode : this.$refs.outupdate[4].modelvalue,//医院编号
					terminalHospital: this.TerminalHospitalName == this.$refs.outupdate[6].modelvalue ? this
						.TerminalHospital : this.$refs.outupdate[6]
						.modelvalue, //终端医院（二级经销商创建的出库单，且填写的hospital的HosType!=医院时传）
					remark: this.$refs.outupdate[5].modelvalue, //备注
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: null, //出库唯一码明细（产品线开通唯一码时传）
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.$parent.wmsOtherOutList()
					this.dialogVisibleoutboundorderedit = false
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
				}
			},
			async OtherOutAddTow(val) {
				// //console.log(this.$refs.AddDialog,'this.$refs.AddDialog');
				// let arr1= [] 
				// this.$refs.AddDialog.tableDataDetailunNo.map((item,index)=>{
				//   let obj = {
				//     invCode: item.InvCode,
				//     batch: item.Batch,
				//     quantity: item.Quantity == "" ? null : "",
				//     taxUnitPrice: null,
				//   }
				//   arr1.push(obj)
				// if (!this.$refs.outadd[0].modelvalue) {
				//   this.$message.warning("出库单号不能为空！")
				//   return
				// }
				if (!this.$refs.outadd[1].modelvalue) {
					this.$message.warning("出库日期不能为空！")
					return
				}
				if (!this.$refs.outadd[2].modelvalue) {
					this.$message.warning("产品线不能为空！")
					return
				}
				if (!this.$refs.outadd[3].modelvalue) {
					this.$message.warning("单据类型不能为空！")
					return
				}
				if (!this.$refs.outadd[4].modelvalue) {
					this.$message.warning("付款方不能为空！")
					return
				}
				// })
				let {
					code,
					data,
					message
				} = await OtherOutAdd({
					dpDate: this.$refs.outadd[1].modelvalue, //出库日期
					voucherType: this.$refs.outadd[3].modelvalue, //单据类型
					invClass: this.$refs.outadd[2].modelvalue, //产品线编码
					vouCode: this.$refs.outadd[0].modelvalue, //经销商出库单号
					cusCode: this.$refs.outadd[4].modelvalue, //二级经销商编号
					// hospital: this.$refs.outadd[4].modelvalue,//医院编号
					terminalHospital: this.$refs.outadd[6]
						.modelvalue, //终端医院（二级经销商创建的出库单，且填写的hospital的HosType!=医院时传）
					remark: this.$refs.outadd[5].modelvalue, //备注
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: null, //出库唯一码明细（产品线开通唯一码时传）
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.$parent.wmsOtherOutList()
					this.dialogVisibleoutboundorder = false
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
				}
			},
			// 添加保存
			async addsave() {
				// if (!this.$refs.outadd[0].modelvalue) {
				// 	this.$message.warning("出库单号不能为空！")
				// 	return
				// }
				if (!this.$refs.outadd[1].modelvalue) {
					this.$message.warning("出库日期不能为空！")
					return
				}
				if (!this.$refs.outadd[2].modelvalue) {
					this.$message.warning("产品线不能为空！")
					return
				}
				let {
					code,
					data,
					message
				} = await OtherOutAdd({
					vouCode: this.$refs.outadd[0].modelvalue, //经销商出库单号
					dpDate: this.$refs.outadd[1].modelvalue, //出库日期
					invClass: this.$refs.outadd[2].modelvalue, //产品线编码
					cusCode: this.$refs.outadd[3].modelvalue, //经销商
					remark: this.$refs.outadd[4].modelvalue, //备注
					hospital: this.$refs.outadd[5].modelvalue, //寄售方ID
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: this.$refs.AddDialog.tableDataDetailUnique, //出库唯一码明细（产品线开通唯一码时传）
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.$parent.wmsOtherOutList()
					this.dialogVisibleoutboundorder = false
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
				}
			},
			// 修改保存
			async editsave() {
				// if (!this.$refs.outupdate[0].modelvalue) {
				// 	this.$message.warning("出库单号不能为空！")
				// 	return
				// }
				if (!this.$refs.outupdate[1].modelvalue) {
					this.$message.warning("出库日期不能为空！")
					return
				}
				if (!this.$refs.outupdate[2].modelvalue) {
					this.$message.warning("产品线不能为空！")
					return
				}
				let {
					code,
					data,
					message
				} = await OtherOutEdit({
					dpmid: this.dpmid,
					vouCode: this.$refs.outupdate[0].modelvalue, //经销商出库单号
					dpDate: this.$refs.outupdate[1].modelvalue, //出库日期
					invClass: this.$refs.outupdate[2].modelvalue, //产品线编码
					cusCode: this.$refs.outupdate[3].modelvalue, //经销商
					remark: this.$refs.outupdate[4].modelvalue, //备注
					hospital: this.$refs.outupdate[5].modelvalue, //寄售方ID
					detailList: this.$refs.AddDialog.tableDataDetail.length == 0 ? this.$refs.AddDialog
						.tableDataDetailunNo : this.$refs.AddDialog.tableDataDetail, //出库明细（产品线未开通唯一码时传）
					detailUniqueList: this.$refs.AddDialog.tableDataDetailUnique, //出库唯一码明细（产品线开通唯一码时传）
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '保存成功'
					});
					this.$parent.wmsOtherOutList()
					this.dialogVisibleoutboundorderedit = false
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
				}
			},
			// 详情
			async wmsOtherOutInfo() {
				let {
					code,
					data

				} = await wmsOtherOutInfo({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.$refs.outupdate[0].modelvalue = data.VouCode
					this.$refs.outupdate[1].modelvalue = data.DPDate
					this.$refs.outupdate[2].modelvalue = data.InvClass
					this.$refs.outupdate[3].modelvalue = data.CusCode
					this.$refs.outupdate[4].modelvalue = data.Remark
					this.$refs.AddDialog.tableDataDetail.length = 0
					this.editformdatadialog[3].options = [{
						key: data.CusCode,
						value: data.CusName
					}]
					let arr = []
					let obj = {}
					data.DetailUniqueList.map((item, index) => {
						let num = parseInt(Math.random() * 10000)
						obj = Object.assign({}, item, {
							ids: num
						})
						arr.push(obj)
					})
					this.$refs.AddDialog.tableDataDetail = data.DetailList
					this.$refs.AddDialog.tableDataDetailunNo = data.DetailList
					this.$refs.AddDialog.tableDataDetailUnique = arr
					if (this.CusTypeFlog == 1) {
						this.$refs.outupdate[4].modelvalue = data.CusName
						this.CusCode = data.CusCode
						this.CusCodeName = data.CusName
					}
					if (this.CusTypeFlog == 2) {
						// if(data.TerminalHospitalName){
						// this.$refs.outupdate[6].selcoms = true
						// }
						this.$refs.outupdate[4].modelvalue = data.HospitalName
						this.$refs.outupdate[6].modelvalue = data.TerminalHospitalName
						this.TerminalHospitalName = data.TerminalHospitalName
						this.TerminalHospital = data.TerminalHospital
						this.HospitalCode = data.Hospital
						this.HospitalName = data.HospitalName
						this.HospitalListID(data.Hospital)
					}
					this.inventoryClassInfo(this.$refs.outupdate[2].modelvalue)
					// this.$refs.AddDialog.wmsOtherOutDetail()
				}
			},
			// 单据类型下拉
			async helperDPVoucherType() {
				let {
					code,
					data
				} = await HelperDPVoucherType({})
				if (code == 0) {
					this.formdatadialog[3].options = []
					this.editformdatadialog[3].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdatadialog[3].options.push(obj)
						this.editformdatadialog[3].options.push(obj)
					})
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdatadialog[2].options = []
					this.editformdatadialog[2].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdatadialog[2].options.push(obj)
						this.editformdatadialog[2].options.push(obj)
					})
				}
			},
			// 导入
			async Import(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在导入...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await wmsOtherOutImport(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
					loading.close();
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
				} else {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}
				this.$parent.wmsOtherOutList()
			},
			// 判断修改是否可用
			async CusType() {
				let {
					data,
					code
				} = await CusType({})
				if (code == 0) {
					// this.CusTypeState = data.CusType
					if (data.CusType == "") {
						this.editops = true //测试中
						this.CusTypeFlog = 0
					} else if (data.CusType == "平台") {
						this.CusTypeFlog = 1
					} else if (data.CusType == "经销商") {
						this.CusTypeFlog = 2
					}
				}
			},
			// 删除
			async wmsOtherOutDelete() {
				let {
					code,
					message,
					data
				} = await wmsOtherOutDelete({
					dpmiDs: this.dpmidarr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.dpmidarr.length = 0
					this.$parent.wmsOtherOutList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else {
					this.title = "删除结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$notify.error({
						title: '错误',
						message: message,
						duration: 2000
					});
				}
			},
			// 审核
			async wmsOtherOutVerify() {
				let {
					code,
					message,
					data
				} = await wmsOtherOutVerify({
					dpmiDs: this.dpmidarr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '审核成功'
					});
					this.dpmidarr.length = 0
					this.$parent.wmsOtherOutList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 1) {
					this.$message({
						type: 'success',
						message: message
					});
					this.$parent.wmsOtherOutList()
				} else {
					this.title = "审核结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$notify.error({
						title: '错误',
						message: message,
						duration: 2000
					});
				}
			},
			// 弃审
			async wmsOtherOutUnVerify() {
				let {
					code,
					message,
					data
				} = await wmsOtherOutUnVerify({
					dpmiDs: this.dpmidarr
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '弃审成功'
					});
					this.dpmidarr.length = 0
					this.$parent.wmsOtherOutList()
					this.$refs.OutboudreRef.$refs.fileTableSelect.clearSelection()
				} else if (code == 1) {
					this.$message({
						type: 'success',
						message: message
					});
					this.$parent.wmsOtherOutList()
				} else {
					this.title = "弃审结果"
					this.dialogVisiblesqsjg = true
					this.tableDataqsjg = data
					this.$notify.error({
						title: '错误',
						message: message,
						duration: 2000
					});
				}
			},
			async OtherOutImportDetail() {
				let {
					code,
					message
				} = await OtherOutImportDetail({
					DetailList: this.AddTableSelection
				})
			},
			async HospitalListID(query) {
				this.loading = true
				let {
					data,
					code
				} = await HospitalInfo({
					hpid: query,
				})
				if (code == 0) {
					if (this.CusTypeFlog == 2) {
						if (data.HosType == "医院") {
							this.formdatadialog[6].selcoms = false
							this.editformdatadialog[6].selcoms = false
						} else {
							this.formdatadialog[6].selcoms = true
							this.editformdatadialog[6].selcoms = true
						}
					}
				}
				this.loading = false
			},
			// 终端医院（二级经销商创建的出库单，且填写的hospital的HosType
			HosTypeChage(e) {
				if (e.modelvalue == '') {
					if (this.dialogVisibleoutboundorderedit) {
						this.$refs.outupdate[6].modelvalue = ''
						this.editformdatadialog[6].selcoms = false
					} else if (this.dialogVisibleoutboundorder) {
						this.$refs.outadd[6].modelvalue = ''
						this.formdatadialog[6].selcoms = false
					}
				}
				if (this.CusTypeFlog == 2) {
					if (e.modelvalue != '') {
						this.HospitalListID(e.modelvalue)
					}
				}
			},
			//多选
			handleSelectionChange(val) {
				if (val && val.length > 0) {
					this.dpmidarr = []
					this.rowboo = true
					val.map((item, index) => {
						this.dpmidarr.push(item.DPMID)
					})
					if (val.length === 1) {
						this.dpmid = val[0].DPMID
						if (val[0].Status == 1) {
							this.editops = true
						} else {
							this.editops = false
						}
					} else {
						this.editops = false
					}
				} else {
					this.dpmidarr = []
					this.rowboo = false
					this.editops = false
				}

			},

			handleSelectionChangeAddDialogFromTable(val) {
				this.AddTableSelectiondetailList = val
			},
			handleSelectionChanges() {},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			addclick() {},
			commclick(type) {
				this[type] = true
			},
			cancelinvoicephoto() {

			},
			dialogOKinvoicephoto() {

			},
			addckd(val) {
				this.HosTypestate = 1
				this.dialogindex = "add"
				//this.helperDPVoucherType()
				this.inventoryClassList()
				this.dialogVisibleoutboundorder = true
				this.$emit('addckd', val)
				return
			},
			updateckd() {
				if (this.dpmidarr && this.dpmidarr.length === 1) {
					this.dpmid = this.dpmidarr[0]
					this.rowboo = true
				}
				if (this.rowboo == true) {
					//this.editformdatadialog[6].selcoms = false
					// this.CusType()
					this.wmsOtherOutInfo()
					//this.helperDPVoucherType()
					this.inventoryClassList()
					this.dialogVisibleoutboundorderedit = true
					this.dialogindex = "update"
					this.$emit('updateckd')
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要操作的数据！'
				});

			},
			canceloutboundorderedit() {
				this.$parent.wmsOtherOutList()
				this.dialogVisibleoutboundorderedit = false
			},
			dialogOKcanceloutboundorderedit() {
				this.$parent.wmsOtherOutList()
				this.$refs.outupdate.map((item, index) => {
					item.modelvalue = ''
				})
				this.$refs.AddDialog.tableDataDetail.length = 0
				this.$refs.AddDialog.tableDataDetailunNo.length = 0
				this.$refs.AddDialog.tableDataDetailUnique.length = 0
				this.dialogVisibleoutboundorderedit = false
			},
			canceloutboundorder() {
				this.$parent.wmsOtherOutList()
				this.dialogVisibleoutboundorder = false
			},
			dialogOKcanceloutboundorder() {
				this.$parent.wmsOtherOutList()
				this.$refs.outadd.map((item, index) => {
					item.modelvalue = ''
				})
				this.$refs.AddDialog.tableDataDetail.length = 0
				this.$refs.AddDialog.tableDataDetailunNo.length = 0
				this.$refs.AddDialog.tableDataDetailUnique.length = 0
				this.dialogVisibleoutboundorder = false
			},
			showclick() {
				this.showorhide = true
			},
			hide() {
				this.showorhide = false

			},
			select() {

			},
			reset() {

			},
			/** 
			 * 如果当前登录的是一级经销商
			 * 下拉框就是二级经销商
			 * */

			async CustomerList(query) {
				this.loading = true
				let {
					data,
					code
				} = await CustomerList({
					cusName: query,
					Actived: 1
				})
				if (code == 0) {
					this.formdatadialog[3].options = []
					this.editformdatadialog[3].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName
						}
						this.formdatadialog[3].options.push(obj)
						this.editformdatadialog[3].options.push(obj)
					})
					this.loading = false
				}
			},
			/**
			 * 如果当前登录的是二级经销商
			 * 下拉框就是医院
			 */
			async HospitalList(query) {
				this.loading = true
				let {
					data,
					code
				} = await HospitalList({
					hpName: query,
				})
				if (code == 0) {
					this.formdatadialog[4].options = []
					this.editformdatadialog[4].options = []
					if (this.HosTypestate == 2) {
						this.formdatadialog[6].options = []
					}
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.formdatadialog[4].options.push(obj)
						this.editformdatadialog[4].options.push(obj)
						if (this.HosTypestate == 2) {
							this.formdatadialog[6].options.push(obj)
						}
					})
				}
				this.loading = false
			},
			async remoteHosType(query) {
				this.loading = true
				let {
					data,
					code
				} = await HospitalList({
					hpName: query,
				})
				if (code == 0) {
					this.formdatadialog[6].options = []
					this.editformdatadialog[6].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.formdatadialog[6].options.push(obj)
						this.editformdatadialog[6].options.push(obj)
					})
				}
				this.loading = false
			},
			//寄售方
			async getHospList(query) {
				let {
					data,
					code
				} = await HospitalList({
					hpName: query,
				})
				if (code == 0) {
					this.formdatadialog[5].options = []
					this.editformdatadialog[5].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.formdatadialog[5].options.push(obj)
						this.editformdatadialog[5].options.push(obj)
					})
				}
			},
			remoteMethodtows(query, i) {
				if (i === 3) {
					this.CustomerList(query)
				} else {
					this.getHospList(query);
				}
			},
			onRowClick(val) {
				this.rowboo = true
				this.dpmid = val.DPMID
				//console.log(val, "val")
				if (val.Status == 1) {
					this.editops = true
				}
				if (val.Status == 0) {
					this.editops = false
				}
				this.$emit("onRowClick", val)
			},
			OtherOutExport() {
				this.$emit('OtherOutExport')
			},
			invClass(e) {
				this.invClassCode = e.modelvalue
				this.inventoryClassInfo(e.modelvalue)
			},
			// 判断是否开启唯一码
			async inventoryClassInfo(invClass) {
				let {
					code,
					data
				} = await InventoryClassInfo({
					invClass: invClass
				})
				if (code == 0) {
					if (data.IsBarCodeControl == 1) {
						let arr = [{
								title: '明细'
							},
							{
								title: '唯一码'
							}
						]

						this.$refs.AddDialog.wtypestate = false
						this.$refs.AddDialog.Quantityflag = true
						this.Uniqueflag = true
						this.Detailflag = false
						this.state = arr

					} else if (data.IsBarCodeControl == 0) {
						let arr = [{
							title: '明细'
						}]
						// //console.log(this.$refs.AddDialog,'this.$refs.AddDialog');
						this.$refs.AddDialog.wtypes = 1
						this.$refs.AddDialog.onchage = 0
						this.$refs.AddDialog.wtypestate = true
						this.$refs.AddDialog.Quantityflag = false
						this.Uniqueflag = false
						this.Detailflag = true
						// this.wtype = 0
						this.state = arr
					}
				}
			},
			adduser() {
				this.dialogVisibles = true
				//console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
			},
			cancel() {
				// this.dialogVisibles = false
			},
			dialogOK() {
				// this.dialogVisibles = false
			},
			shen() {
				if (this.dpmidarr.length > 0) {
					this.dialogVisibleshen = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要审核的数据(多选)！'
				});
			},
			cancelshen() {
				this.dialogVisibleshen = false
			},
			dialogOKshen() {
				this.wmsOtherOutVerify()
				this.dialogVisibleshen = false
			},
			qshen() {
				if (this.dpmidarr.length > 0) {
					this.dialogVisibleqshen = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要弃审的数据！'
				});


			},
			dialogOKqshen() {
				this.wmsOtherOutUnVerify()
				this.dialogVisibleqshen = false
			},
			cancelqshen() {
				this.dialogVisibleqshen = false
			},
			del() {
				if (this.dpmidarr.length > 0) {
					this.dialogVisibledel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});
			},
			dialogOKdel() {
				this.wmsOtherOutDelete()
				this.dialogVisibledel = false
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			cancelqsjg() {
				this.dialogVisiblesqsjg = false
			},
			dialogOKqsjg() {
				this.dialogVisiblesqsjg = false
			},
			GuidanceVideo() {
				this.dialogVisibGuidanceVideo = true
			},
			cancelGuidanceVideo() {
				this.dialogVisibGuidanceVideo = false
			},
			dialogOKGuidanceVideo() {
				this.dialogVisibGuidanceVideo = false
			},
		},
		watch: {
			dialogVisibleoutboundorder: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						this.$refs.outadd.map((item, index) => {
							item.modelvalue = ''
						})
						this.$refs.AddDialog.tableDataDetail.length = 0
						this.$refs.AddDialog.tableDataDetailunNo.length = 0
						this.$refs.AddDialog.tableDataDetailUnique.length = 0
					}
				},
				deep: true
			},
			// dialogVisibleoutboundorderedit: {
			// 	handler(newVal, oldVal) {
			// 		if (newVal == false) {
			// 			this.$refs.outupdate.map((item, index) => {
			//   		item.modelvalue = ''
			// 			})
			// 			this.$refs.AddDialog.tableDataDetail.length = 0
			// 			this.$refs.AddDialog.tableDataDetailunNo.length = 0
			//   	this.$refs.AddDialog.tableDataDetailUnique.length = 0
			// 		}
			// 	},
			// 	deep: true
			// },
			dialogVisibGuidanceVideo: {
				handler(newVal, oldVal) {
					if (newVal == false) {
						// 弹窗关闭暂定视频
						this.$refs.outbouVideo.$refs.videoPlayer.pause()
					}
				},
				deep: true
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.froms {
			width: 100%;

			.inputtop {
				width: 980px;
				height: 90px;
				// box-shadow: 0px 1px 4px 0px rgba(56, 43, 43, 0.1);
				border-bottom: 1px solid #f0f0f0;
				background-color: #ffffff;
				padding-top: 15px;
				padding-bottom: 70px;
				animation: shows 0.2s linear;
				overflow: hidden;
			}

			.inputtops {
				width: 980px;
				height: 0;
				// box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
				border-bottom: 1px solid #f0f0f0;
				border-top: 1px solid #f0f0f0;
				background-color: #ffffff;
				padding-top: 15px;
				padding-bottom: 70px;
				overflow: hidden;
				// animation: hides 0.5s ease-in;
			}
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>